<script lang="ts">
	import { onMount } from "svelte";
	import Icon from "./Icon.svelte";
	import arrowRight from "../../../core/assets/icons/arrow-right.svg?raw";

	export let ariaPrevious = "Previous";
	export let ariaNext = "Next";

	let scroller: HTMLDivElement;
	let canScrollPrevious = false;
	let canScrollNext = false;

	function update(): void {
		canScrollPrevious = scroller.scrollLeft > 1;
		canScrollNext = scroller.scrollLeft + scroller.clientWidth < scroller.scrollWidth - 1;
	}

	function scroll(direction: -1 | 1): void {
		scroller.scrollBy({ left: direction * scroller.clientWidth, behavior: "smooth" });
	}

	onMount(() => {
		update();
		const observer = new ResizeObserver(update);
		observer.observe(scroller);
		return () => {
			observer.disconnect();
		};
	});

	const buttonClass =
		"bg-ltprimary-300 hover:bg-ltprimary absolute top-1/2 z-10 flex size-8 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full border-0 p-0 text-white transition-colors duration-300";
</script>

<div class="relative -mt-px">
	<div
		bind:this={scroller}
		on:scroll={update}
		class="flex snap-x snap-mandatory overflow-x-auto [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
	>
		<slot />
	</div>
	{#if canScrollPrevious}
		<button
			type="button"
			aria-label={ariaPrevious}
			class="{buttonClass} left-2"
			on:click={() => {
				scroll(-1);
			}}
		>
			<Icon icon={arrowRight} class="size-4 rotate-180" />
		</button>
	{/if}
	{#if canScrollNext}
		<button
			type="button"
			aria-label={ariaNext}
			class="{buttonClass} right-2"
			on:click={() => {
				scroll(1);
			}}
		>
			<Icon icon={arrowRight} class="size-4" />
		</button>
	{/if}
</div>
